export default __webpack_public_path__ + "img/404-page-image.svg";